import React from 'react';
import useDataContext from 'data/context/data';

import { SHOP_CATEGORIES } from '../specifications/lists';
import { Head, Layout } from '../components/layout';
import { ProductsSection } from '../components/custom/mainSections';

const ShopPage = () => {
  const dataContext = useDataContext();

  const categories = dataContext.getCategories(SHOP_CATEGORIES);

  return (
    <>
      <Head
        title="Shop All Photo Prints, Books & Gifts"
        description="Browse the full Parabo Press shop. Photo prints, photo books, calendars, wall art, magnets and photo gifts, all printed from your own photos."
      />

      <Layout>
        {categories.map(category => (
          <React.Fragment key={category.id}>
            {category.data.map((item, index) => {
              let title = item.title;
              if (!title && index === 0) {
                title = category.name;
              }

              return (
                <ProductsSection
                  key={item.key}
                  title={title.toUpperCase()}
                  subCategories={item.subCategories}
                  products={item.products}
                  productsFirst={item.productsFirst}
                  xs={12}
                  md={4}
                />
              );
            })}
          </React.Fragment>
        ))}
      </Layout>
    </>
  );
};

export default ShopPage;
